import { DoctorMSProcedureEntity } from "lib/graphql/megaSchema";

export const isUsg = (e: any): e is DoctorMSProcedureEntity => {
  return e.type === "USG";
};
